import { RevenueData } from '../../types';

export const mockRevenueData: RevenueData = {
  overview: {
    totalRevenue: 487000,
    monthlyRevenue: 89200,
    yearlyRevenue: 487000,
    projectedRevenue: 625000,
  },
  breakdown: {
    byServiceType: [
      { service: 'Personal Training', revenue: 198000, percentage: 40.7, clientCount: 124 },
      { service: 'Nutrition Coaching', revenue: 146100, percentage: 30.0, clientCount: 167 },
      { service: 'Group Classes', revenue: 97400, percentage: 20.0, clientCount: 213 },
      { service: 'Online Programs', revenue: 45500, percentage: 9.3, clientCount: 89 },
    ],
    byClientTier: [
      { tier: 'Premium', revenue: 267000, percentage: 54.8, avgPrice: 3000 },
      { tier: 'Standard', revenue: 146200, percentage: 30.0, avgPrice: 1180 },
      { tier: 'Basic', revenue: 73800, percentage: 15.2, avgPrice: 2170 },
    ],
    byCoach: [
      { coachName: 'Sarah Johnson', revenue: 89500, clientCount: 47, avgRevenue: 1904 },
      { coachName: 'Mike Thompson', revenue: 73200, clientCount: 38, avgRevenue: 1926 },
      { coachName: 'Emily Davis', revenue: 67800, clientCount: 41, avgRevenue: 1654 },
      { coachName: 'Alex Rodriguez', revenue: 59300, clientCount: 32, avgRevenue: 1853 },
      { coachName: 'Jessica Chen', revenue: 54100, clientCount: 35, avgRevenue: 1546 },
      { coachName: 'David Wilson', revenue: 48900, clientCount: 29, avgRevenue: 1686 },
    ],
    byMonth: [
      { month: '2023-07', revenue: 68200, target: 65000, variance: 3200 },
      { month: '2023-08', revenue: 71500, target: 67000, variance: 4500 },
      { month: '2023-09', revenue: 69800, target: 68000, variance: 1800 },
      { month: '2023-10', revenue: 75300, target: 70000, variance: 5300 },
      { month: '2023-11', revenue: 78900, target: 72000, variance: 6900 },
      { month: '2023-12', revenue: 82400, target: 75000, variance: 7400 },
      { month: '2024-01', revenue: 84600, target: 77000, variance: 7600 },
      { month: '2024-02', revenue: 87200, target: 79000, variance: 8200 },
      { month: '2024-03', revenue: 89100, target: 81000, variance: 8100 },
      { month: '2024-04', revenue: 91800, target: 83000, variance: 8800 },
      { month: '2024-05', revenue: 88700, target: 85000, variance: 3700 },
      { month: '2024-06', revenue: 89200, target: 87000, variance: 2200 },
    ],
  },
  forecasting: {
    trend: 'increasing',
    projection: 625000,
    seasonality: [
      { month: 'Jan', factor: 1.15, confidence: 0.87 },
      { month: 'Feb', factor: 1.09, confidence: 0.89 },
      { month: 'Mar', factor: 1.12, confidence: 0.91 },
      { month: 'Apr', factor: 1.05, confidence: 0.88 },
      { month: 'May', factor: 0.98, confidence: 0.85 },
      { month: 'Jun', factor: 0.94, confidence: 0.83 },
      { month: 'Jul', factor: 0.89, confidence: 0.79 },
      { month: 'Aug', factor: 0.91, confidence: 0.81 },
      { month: 'Sep', factor: 1.03, confidence: 0.86 },
      { month: 'Oct', factor: 1.08, confidence: 0.88 },
      { month: 'Nov', factor: 1.11, confidence: 0.90 },
      { month: 'Dec', factor: 1.18, confidence: 0.92 },
    ],
    confidence: 0.87,
  },
  payments: {
    outstandingInvoices: 23400,
    overduePayments: 8750,
    paymentMethods: [
      { method: 'Credit Card', count: 187, percentage: 75.8, avgAmount: 1890 },
      { method: 'Bank Transfer', count: 42, percentage: 17.0, avgAmount: 2340 },
      { method: 'PayPal', count: 13, percentage: 5.3, avgAmount: 1650 },
      { method: 'Cash', count: 5, percentage: 2.0, avgAmount: 980 },
    ],
    averagePaymentTime: 7.2, // days
  },
};

export const mockRevenueGrowthTrend = [
  { month: '2023-07', revenue: 68200, growth: 8.5, mrr: 71400, arr: 856800 },
  { month: '2023-08', revenue: 71500, growth: 10.2, mrr: 74800, arr: 897600 },
  { month: '2023-09', revenue: 69800, growth: 7.8, mrr: 73100, arr: 877200 },
  { month: '2023-10', revenue: 75300, growth: 12.4, mrr: 78900, arr: 946800 },
  { month: '2023-11', revenue: 78900, growth: 15.7, mrr: 82700, arr: 992400 },
  { month: '2023-12', revenue: 82400, growth: 18.9, mrr: 86400, arr: 1036800 },
  { month: '2024-01', revenue: 84600, growth: 21.3, mrr: 88700, arr: 1064400 },
  { month: '2024-02', revenue: 87200, growth: 23.8, mrr: 91400, arr: 1096800 },
  { month: '2024-03', revenue: 89100, growth: 25.1, mrr: 93500, arr: 1122000 },
  { month: '2024-04', revenue: 91800, growth: 27.4, mrr: 96300, arr: 1155600 },
  { month: '2024-05', revenue: 88700, growth: 24.9, mrr: 93000, arr: 1116000 },
  { month: '2024-06', revenue: 89200, growth: 25.3, mrr: 93500, arr: 1122000 },
];

export const mockRevenueForecasting = [
  { month: '2024-07', projected: 91800, confidence: 0.87, lower: 85200, upper: 98400 },
  { month: '2024-08', projected: 94500, confidence: 0.85, lower: 87600, upper: 101400 },
  { month: '2024-09', projected: 97200, confidence: 0.83, lower: 89800, upper: 104600 },
  { month: '2024-10', projected: 99900, confidence: 0.81, lower: 92100, upper: 107700 },
  { month: '2024-11', projected: 102600, confidence: 0.79, lower: 94400, upper: 110800 },
  { month: '2024-12', projected: 105300, confidence: 0.77, lower: 96700, upper: 113900 },
];

export const mockSubscriptionMetrics = [
  { metric: 'Monthly Churn Rate', value: 7.2, target: 5.0, trend: 'down', change: -1.8 },
  { metric: 'Customer Lifetime Value', value: 4850, target: 5000, trend: 'up', change: 320 },
  { metric: 'Average Contract Value', value: 2890, target: 3000, trend: 'up', change: 180 },
  { metric: 'Renewal Rate', value: 89.3, target: 92.0, trend: 'up', change: 3.1 },
  { metric: 'Upsell Rate', value: 23.7, target: 25.0, trend: 'stable', change: 0.4 },
  { metric: 'Revenue per Client', value: 1970, target: 2100, trend: 'up', change: 150 },
];

export const mockPaymentAnalysis = [
  { period: 'Current Month', onTime: 184, late: 18, failed: 5, total: 207 },
  { period: 'Last Month', onTime: 176, late: 22, failed: 8, total: 206 },
  { period: 'Two Months Ago', onTime: 168, late: 19, failed: 6, total: 193 },
  { period: 'Three Months Ago', onTime: 159, late: 25, failed: 9, total: 193 },
]; 